import { render, staticRenderFns } from "./banner-uploader.vue?vue&type=template&id=47be43be&scoped=true&"
import script from "./banner-uploader.vue?vue&type=script&lang=js&"
export * from "./banner-uploader.vue?vue&type=script&lang=js&"
import style0 from "./banner-uploader.vue?vue&type=style&index=0&id=47be43be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be43be",
  null
  
)

export default component.exports